export const titles = {
    fontWeight: "bold",
    textDecoration: "underline"
};

export const body = {
    paddingRight: "30px"
};

export const columnRight = {
    textAlign: "right"
};

export const saveButton = {
    transition: "all 0.5s ease-out"
};

export const mapError = {
    fontWeight: "bold",
    color: "red"
};
